module.exports = "https://static.moomoo.com/components/common-trade-idea-main/images/icon4.86d595974f.png";